import { IOption } from 'shared-components';

import { UserRole } from '@/store/auth/types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { ActionSelection } from '../../../types';

export const getImmigrationProvidersDropDownOptions = (userRole: UserRole) => {
  const options: Array<IOption> = [];

  if (hasPerm(userRole, P.EDIT_STUDENT_IMMIGRATION_PROVIDERS)) {
    options.push({
      label: 'Immigration',
      value: ActionSelection.IMMIGRATION_PROVIDERS,
    });
  }

  return options;
};
